import { useRef, useState } from 'react';

export default function PuzzleGame() {
  const canvasRef = useRef(null);
  const screenRef = useRef(null);
  const [started, setStarted] = useState(false);

  const startGame = () => {
    if (started) return;
    setStarted(true);

    const canvas = canvasRef.current;
    const screen = screenRef.current;
    canvas.width = screen.offsetWidth;
    canvas.height = screen.offsetHeight;
    const ctx = canvas.getContext('2d');
    const W = canvas.width, H = canvas.height;

    const COLS = 6, ROWS = 7;
    const candies = ['🍬', '🍭', '🍫', '🍡', '🧁', '🍩'];
    let cellW = Math.floor(W / COLS), cellH = Math.floor((H * 0.75) / ROWS);
    let grid = [], score = 0, selected = null;

    function makeGrid() {
      grid = [];
      for (let r = 0; r < ROWS; r++) {
        grid.push([]);
        for (let c = 0; c < COLS; c++) grid[r].push(Math.floor(Math.random() * candies.length));
      }
    }
    makeGrid();

    function drawGrid() {
      const bg = ctx.createLinearGradient(0, 0, 0, H);
      bg.addColorStop(0, '#1a1040'); bg.addColorStop(1, '#0d0a25');
      ctx.fillStyle = bg; ctx.fillRect(0, 0, W, H);

      ctx.fillStyle = '#F5A623'; ctx.font = `bold ${W * 0.055}px Cairo`; ctx.textAlign = 'center';
      ctx.fillText('نقاط: ' + score, W / 2, 28);
      ctx.fillStyle = 'rgba(255,255,255,0.5)'; ctx.font = `${W * 0.032}px Cairo`;
      ctx.fillText('اضغط على قطعتين متجاورتين لمبادلتهم', W / 2, H * 0.92);

      const offY = H * 0.06;
      for (let r = 0; r < ROWS; r++) {
        for (let c = 0; c < COLS; c++) {
          const x = c * cellW, y = offY + r * cellH;
          const isSel = selected && selected[0] === r && selected[1] === c;
          ctx.fillStyle = isSel ? 'rgba(245,166,35,0.4)' : 'rgba(255,255,255,0.05)';
          ctx.beginPath(); ctx.roundRect(x + 2, y + 2, cellW - 4, cellH - 4, 6); ctx.fill();
          if (isSel) {
            ctx.strokeStyle = '#F5A623'; ctx.lineWidth = 2;
            ctx.beginPath(); ctx.roundRect(x + 2, y + 2, cellW - 4, cellH - 4, 6); ctx.stroke();
          }
          ctx.font = `${Math.min(cellW, cellH) * 0.62}px serif`;
          ctx.textAlign = 'center';
          ctx.fillText(candies[grid[r][c]], x + cellW / 2, y + cellH * 0.72);
        }
      }
    }

    function checkMatches() {
      let matched = new Set();
      for (let r = 0; r < ROWS; r++)
        for (let c = 0; c < COLS - 2; c++)
          if (grid[r][c] === grid[r][c + 1] && grid[r][c] === grid[r][c + 2]) {
            matched.add(r + ',' + c); matched.add(r + ',' + (c + 1)); matched.add(r + ',' + (c + 2));
          }
      for (let r = 0; r < ROWS - 2; r++)
        for (let c = 0; c < COLS; c++)
          if (grid[r][c] === grid[r + 1][c] && grid[r][c] === grid[r + 2][c]) {
            matched.add(r + ',' + c); matched.add((r + 1) + ',' + c); matched.add((r + 2) + ',' + c);
          }
      if (matched.size > 0) {
        score += matched.size * 10;
        matched.forEach(key => {
          const [r, c] = key.split(',').map(Number);
          grid[r][c] = Math.floor(Math.random() * candies.length);
        });
        setTimeout(() => { checkMatches(); drawGrid(); }, 200);
      }
    }

    canvas.addEventListener('click', (e) => {
      const r2 = canvas.getBoundingClientRect();
      const mx = (e.clientX - r2.left) * (W / r2.width);
      const my = (e.clientY - r2.top) * (H / r2.height);
      const offY = H * 0.06;
      const c = Math.floor(mx / cellW), r = Math.floor((my - offY) / cellH);
      if (r < 0 || r >= ROWS || c < 0 || c >= COLS) return;
      if (!selected) { selected = [r, c]; }
      else {
        const [sr, sc] = selected;
        const adj = (Math.abs(sr - r) === 1 && sc === c) || (Math.abs(sc - c) === 1 && sr === r);
        if (adj) { let tmp = grid[sr][sc]; grid[sr][sc] = grid[r][c]; grid[r][c] = tmp; checkMatches(); }
        selected = null;
      }
      drawGrid();
    });

    drawGrid();
    checkMatches();
  };

  return (
    <div className="demo-screen" ref={screenRef} onClick={!started ? startGame : undefined}>
      <div className="demo-canvas">
        <canvas ref={canvasRef} />
      </div>
      {!started && (
        <div className="play-overlay">
          <div className="play-btn-big">▶</div>
          <div className="play-hint">اضغط للعب</div>
        </div>
      )}
    </div>
  );
}
